/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_Detail_Remove_From_Company_TitleInputs */

const en_admin_user_detail_remove_from_company_title = /** @type {(inputs: Admin_User_Detail_Remove_From_Company_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove from company`)
};

const de_admin_user_detail_remove_from_company_title = /** @type {(inputs: Admin_User_Detail_Remove_From_Company_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus Unternehmen entfernen`)
};

/**
* | output |
* | --- |
* | "Remove from company" |
*
* @param {Admin_User_Detail_Remove_From_Company_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_detail_remove_from_company_title = /** @type {((inputs?: Admin_User_Detail_Remove_From_Company_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_Detail_Remove_From_Company_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_detail_remove_from_company_title(inputs)
	return en_admin_user_detail_remove_from_company_title(inputs)
});